export class YandexMetrika {
    track(code, eventCode) {
        try {
            window.ym(911516, code, eventCode);
        } catch (e) {
            //console.log('Ошибка ' + e.name + ':' + e.message + '\n' + e.stack);
        }
    }

    timeClient() {
        this.track('reachGoal', 'time_more_than_x');
    }

    orderComplete() {
        this.track('reachGoal', 'order_complete');
    }


    notFountPage(){
        this.track('reachGoal', 'mn_error_404')
    }

    userAuthorized(user) {
        let userParams = {userId: user.USER_ID};
        this.track('userParams', userParams);
        this.track('params', userParams);
        this.track('setUserID', user.USER_ID);
    }
}


// WEBPACK FOOTER //
// ./blocks/tracker/yandex-metrika.js